import { CritereRecherche } from '../../../configuration/shared/classes/critere-recherche';

export class RoleRecherche {

    ror_id: string;
    ror_role_id: string;
    ror_libelle: string;
    ror_principale: string;
    ror_etat: string;
    ror_date_creation: string;
    criteres: CritereRecherche[];

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.ror_id             = data['ror_id'] ? data['ror_id'] : null;
        this.ror_role_id        = data['ror_role_id'] ? data['ror_role_id'] : null;
        this.ror_libelle        = data['ror_libelle'] ? data['ror_libelle'] : null;
        this.ror_principale     = data['ror_principale'] ? data['ror_principale'] : null;
        this.ror_etat           = data['ror_etat'] ? data['ror_etat'] : null;
        this.ror_date_creation  = data['ror_date_creation'] ? data['ror_date_creation'] : null;

        this.criteres = [];
        if (data['criteres'] && data['criteres'].length > 0) {
            data['criteres'].forEach(element => {
                this.criteres.push(new CritereRecherche(element));
            });
        }
    }

}
